module.exports = __webpack_public_path__ + "static/img/product_images_19_h5_zh.4cf157e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_19_h5_zh.png
// module id = hRP3
// module chunks = 34